import { createContext } from 'react';

import { useFilesPiiOptions } from 'hooks/useFilesPiiOptions';

import { FilesPiiOptions } from 'common/types/files-pii-options.type';

export const FilesPiiOptionsContext = createContext<{
  isLoading: boolean;
  piiOptions: FilesPiiOptions | undefined;
  refetch: () => Promise<Record<string, any>>;
}>({
  isLoading: false,
  refetch: undefined,
  piiOptions: undefined,
});

export const FilesPiiOptionsProvider = ({ children }) => {
  const { data: piiOptions, refetch, isLoading } = useFilesPiiOptions();

  return (
    <FilesPiiOptionsContext.Provider
      value={{
        refetch,
        isLoading,
        piiOptions,
      }}
    >
      {children}
    </FilesPiiOptionsContext.Provider>
  );
};
